import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import { useUserContext } from '../context/user';
import { UserRoles } from '../types/users';
import { Navigate } from "react-router-dom";
import PlaceholderLayout from "../layouts/placeholderLayout";
import AdminLayout from "../layouts/adminLayout";
import ManagerLayout from "../layouts/managerLayout";
import { useSignOut } from "../hooks/useSignOut";
import { AuthType } from '../types/auth';

interface ProtectedRouteProps {
    allowedRoles: UserRoles[];
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, children }) => {
    const { role, jwtToken, jwtRefreshToken, layout, isEnteredPinDate, setLastPageUrl, userAuthType, userPinData } = useUserContext();
    const currentUrl = useLocation().pathname
    const signOut = useSignOut();


    useEffect(() => {
        if (userPinData() && !isEnteredPinDate) {
            setLastPageUrl(currentUrl)
        }
    }, [isEnteredPinDate()]);

    if (!jwtToken) {
        return <Navigate to={'/sign_in/refresh_token'} replace />
    }

    function isNeedEnterPin() {
        switch (userAuthType) {
            case AuthType.PHONE:
                // Открывается пин для задания или ввода - это уже оно определится на самом экране
                return !isEnteredPinDate()
            case AuthType.LOGIN:
                return false
            default:
                return false
        }
    }

    if (isNeedEnterPin()) {
        return <Navigate to={'/sign_in/pin'} replace />
    }

    if (!role || !allowedRoles.includes(role)) {
        return <PlaceholderLayout>
            <div className="w-full flex flex-col justify-center items-center text-red-500 font-bold">
                <div className="mb-4">Доступ для вашей роли запрещён</div>
                <button
                    onClick={signOut}
                    className='
                    w-96
                    hover:bg-yellow-400
                    text-black
                    h-12 inline-flex items-center justify-center flex-[0_0_auto]
                    rounded-lg gap-2.5 px-5 py-4 relative
                    text-center
                    bg-melon-yellow'
                >
                    Выйти
                </button>
            </div>
        </PlaceholderLayout>;
    }

    if (layout === 'ADMIN') {
        return <AdminLayout>{children}</AdminLayout>;
    }
    if (layout === 'MANAGER') {
        return <ManagerLayout>{children}</ManagerLayout>;
    }

    // NOTE: Disable layout 
    signOut();
    return (<div></div>)
    // NOTE: Disable layout 

    // return <PlaceholderLayout>
    //     <div className="w-full flex flex-col justify-center items-center text-red-500 font-bold">
    //         <div className="mb-4">Не выбран сервис</div>
    //         <button
    //             onClick={() => window.location.replace('/layout')}
    //             className='
    //                 w-96
    //                 hover:bg-yellow-400
    //                 text-black
    //                 h-12 inline-flex items-center justify-center flex-[0_0_auto]
    //                 rounded-lg gap-2.5 px-5 py-4 relative
    //                 text-center
    //                 bg-melon-yellow'
    //         >
    //             Выбрать сервис
    //         </button>
    //     </div>
    // </PlaceholderLayout>;
};

export default ProtectedRoute;